import axios from 'axios';

export function apiErrorMessage(err: unknown): string {
    if (axios.isAxiosError(err)) {
        const status = err.response?.status;
        const data = err.response?.data as { message?: string; error?: string | string[] } | string | undefined;

        if (typeof data === 'string' && data.trim()) {
            return data;
        }
        if (data && typeof data === 'object') {
            if (data.message) {
                return data.message;
            }
            if (data.error) {
                return Array.isArray(data.error) ? data.error.join(', ') : String(data.error);
            }
        }
        if (status === 401 || status === 403) {
            return `Not authorized (${status}). Check Auth0 login.`;
        }
        return err.message || 'Request failed';
    }
    if (err instanceof Error) {
        return err.message;
    }
    return 'Request failed';
}
